import { ToastrService } from './toaster.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomErrorService {

    constructor(public toastrService: ToastrService) { }

    /**
    * Common error management.
    * If error is custom controlled error then show message within that error. If not, then show general error
    * @param {*} error
    *
    * @memberof ToastrService
    */
    customErrorManagement(error: any) {

        // if custom error exists then show message, else show generic error
        const e = error.json().Error;
        if (e && e.Code > 900) {
            this.toastrService.showErrorMessage(e.Value);
        } else {
            this.toastrService.showErrorMessage('Error');
        }
    }
}
